import { useEffect } from "react";
import useModal, { MODAL_md } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { _ReportItem, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { Modal } from "../../../theme/Component/Modal";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { SelectAviableReportItems } from "./Selectores/SelectAviableReportItems";

interface Props {
    idReport: number;
}

export const ReportItems = ({ idReport }: Props) => {
    const { instance, lista, setLista, bean, setBean } = useDataBean(_ReportItem);

    const modal = useModal("Agregar Columna de reporte", MODAL_md);
    const modalEdit = useModal("Editar Columna de reporte", MODAL_md);
    const modalDelete = useModal("Eliminar Columna de reporte", MODAL_md);

    useEffect(() => {
        if (idReport) {
            getLista()
        }
    }, [idReport])

    const getLista = () => {
        instance.getReportItemCatalog(idReport).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        );
    }

    const head = [
        { title: 'ID', property: 'IDReportItem', visible: true },
        { title: 'Nombre Columna', property: 'Name', visible: true },
        { title: 'Orden de Columna', property: 'ColumnOrder', visible: true },
        { title: 'Ancho de Columna', property: 'Width', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Columna del Reporte', icono: 'ri-edit-2-line', visible: _single.canDelete(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar Columna del Reporte', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        instance.deleteReportItem(bean.IDReportItem).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const updateItem = () => {
        instance.updateReportItem(bean).then(
            (resp) => {
                getLista();
                modalEdit.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const addItem = () => {
        instance.addReportItem(idReport, bean.ColumnIndex, bean.Width, bean.columnOrder).then(
            (resp) => {
                modal.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({});
        modal.open();
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { 
                    if(bean.ColumnIndex && bean.columnOrder){
                        addItem(); 
                    }else{
                        toast.error("Todos los datos son requeridos")
                    }
                    }} >
                    <div className="row">
                        <div className="col-md-12">
                            <SelectAviableReportItems idReport={idReport} onChange={(e) => { setBean({ ...e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Orden de Columna</label>
                            <input type="number" className="form-control" value={bean.columnOrder} onChange={(e) => {
                                const value = e.target.value ? parseInt(e.target.value) : null
                                setBean({ ...bean, columnOrder: value })
                            }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { updateItem() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Ancho de Columna</label>
                            <input type="number" className="form-control" value={bean.Width} onChange={(e) => {
                                const value = e.target.value ? parseFloat(e.target.value) : null;
                                setBean({ ...bean, Width: value })
                            }} />
                        </div>
                        <div className="col-md-12">
                            <label>Orden de Columna</label>
                            <input type="number" className="form-control" value={bean.ColumnOrder} onChange={(e) => {
                                const value = e.target.value ? parseInt(e.target.value) : null;
                                setBean({ ...bean, ColumnOrder: value })
                            }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={() => { deleteItem() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <p>¿Eliminar Columna {bean.Name}?</p>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}